export default __webpack_public_path__ + "static/media/bhl_logo.7964e2e8.JPG";